import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { useClassNamePrefix } from "../auxiliary/useClassNamePrefix.js";
const ProgressBar = memo(({ progress }) => {
  const clampedProgress = Math.max(0, Math.min(progress, 1));
  const prefix = useClassNamePrefix();
  return /* @__PURE__ */ jsx("div", { className: `${prefix}progressBar`, children: /* @__PURE__ */ jsx("div", { className: `${prefix}progressBar-bar`, style: { transform: `scaleX(${clampedProgress})` } }) });
});
ProgressBar.displayName = "ProgressBar";
export {
  ProgressBar
};
//# sourceMappingURL=ProgressBar.js.map
